<template>
  <v-dialog :value="isFirstPassword" persistent max-width="500" data-test-id="password-confirmation">
    <v-card
      class="white white--text login-block pt-5"
      color="navbar"
      :data-test-id="$tid('password-confirmation', 'content')"
    >
      <h3 class="text-center text--white mb-3" :data-test-id="$tid('password-confirmation', 'title')">
        Смените пароль
      </h3>
      <div class="text-center w-100 d-block mb-3">
        <v-icon size="55" color="write"> mdi-account-clock-outline </v-icon>
      </div>
      <v-card-text class="signin-card-login">
        <v-form ref="form" lazy-validation class="white--text">
          <v-text-field
            :value="user.username"
            label="Логин"
            prepend-icon="mdi-face"
            type="text"
            :readonly="true"
            :data-test-id="$tid('password-confirmation', 'username-input')"
          />
          <v-text-field
            v-model="model.password"
            clearable
            :rules="[rules.required, rules.password]"
            label="Новый пароль"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            color="white"
            class="white--text"
            :data-test-id="$tid('password-confirmation', 'password-input')"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="newPassword"
            clearable
            :rules="[rules.required, verifyPassword]"
            label="Подтвердите пароль"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            color="white"
            class="white--text"
            :data-test-id="$tid('password-confirmation', 'new-password-input')"
            @click:append="showPassword = !showPassword"
            @keyup.enter="confirmPassword"
          />
        </v-form>
        <v-row class="d-flex" style="padding-left: 6px; padding-right: 18px">
          <v-btn
            color="primary"
            class="ma-2"
            style="width: 100%"
            :data-test-id="$tid('password-confirmation', 'confirm-password-btn')"
            @click="confirmPassword"
          >
            Подтвердить изменение пароля
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';
import { useUserStore } from '@/store/user';
import { useSuccessStore } from '@/store/stores';

export default defineComponent({
  name: 'PasswordConfirmation',
  data() {
    return {
      model: {
        password: <string>'',
      },
      newPassword: <string>'',
      showPassword: <boolean>false,
      rules: {
        required: (val: string) => !!val || 'Обязательно для заполнения',
        password: (val: string) => /^[\d\w]{1,18}$/i.test(val) || 'Неправильный формат',
      },
    };
  },
  computed: {
    ...mapState(useUserStore, {
      isFirstPassword: 'isFirstPassword',
      user: 'user',
    }),
  },
  methods: {
    ...mapActions(useSuccessStore, ['addSuccess']),
    ...mapActions(useUserStore, ['getUser']),
    verifyPassword(): boolean | string {
      return this.model.password === this.newPassword || 'Пароль неправильный';
    },
    confirmPassword() {
      //@ts-ignore
      if (this.$refs.form.validate()) {
        const model = { password: this.model.password };
        this.$axios.put(this.$uri.changePassword, model).then(() => {
          this.addSuccess({ message: 'Пароль изменён' });
          this.getUser();
        });
      }
    },
  },
});
</script>
<style lang="sass">
.theme--light .login-block .v-input input
    color: #fff!important
.theme--light .login-block .v-label
    color: #fff!important
.theme--light .login-block .v-icon
    color: #fff!important
.theme--light .login-block .v-counter
    color: #fff!important
.v-responsive__content
    overflow-y: auto !important
</style>
